import { apiPost } from '../client';
import { LONG_TIMEOUT_MS } from '../../config/env';
import type {
  DocumentRequest,
  DocumentResponse,
  OfferDocumentRequest,
  SendDocumentRequest,
  SendDocumentResponse,
} from '../types/documents';

/** e-ticket HTML for one cart (optionally narrowed to a PNR / passenger). */
export function getEticket(body: DocumentRequest): Promise<DocumentResponse> {
  return apiPost<DocumentRequest, DocumentResponse>('Document/Eticket', body, {
    timeoutMs: LONG_TIMEOUT_MS,
  });
}

/** All e-tickets in a cart as one grouped HTML document. */
export function getEticketGrouped(body: DocumentRequest): Promise<DocumentResponse> {
  return apiPost<DocumentRequest, DocumentResponse>('Document/EticketGrouped', body, {
    timeoutMs: LONG_TIMEOUT_MS,
  });
}

/** Hotel voucher HTML (legacy `Otel/Voucher`). */
export function getHotelVoucher(body: DocumentRequest): Promise<DocumentResponse> {
  return apiPost<DocumentRequest, DocumentResponse>('Document/HotelVoucher', body, {
    timeoutMs: LONG_TIMEOUT_MS,
  });
}

/** Flight offer / proposal (legacy `Flight/Offer`). The worker REQUIRES `offerId`
 *  ("Teklif kimliği zorunludur.") — fed from `AirSearchResponse.offerId` by the
 *  "Teklif Oluştur" button on `AirResultsList`. `shoppingCartId` / `flightIds` are
 *  optional narrowing. Response is server-rendered HTML (`{ html }`). */
export function getOfferDocument(body: OfferDocumentRequest): Promise<DocumentResponse> {
  return apiPost<OfferDocumentRequest, DocumentResponse>('Document/Offer', body, {
    timeoutMs: LONG_TIMEOUT_MS,
  });
}

/** Deliver a document by e-mail (legacy SendETicketEmail / SendOffer). The API only
 *  wires the `email` channel today. */
export function sendDocument(body: SendDocumentRequest): Promise<SendDocumentResponse> {
  return apiPost<SendDocumentRequest, SendDocumentResponse>('Document/Send', body, {
    timeoutMs: LONG_TIMEOUT_MS,
  });
}
